import React from 'react';
import { CheckboxTickedLined } from '@tag/tag-icons';

import { Label } from '@tag/tag-components-react-v4';

import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import { Header, HeaderTitleWrapper } from '@ui/ModalWithHeader/styled';

interface ApplyChangeProps {
  onApply: () => void
  onCancel: () => void
}

const ApplyChanges = React.forwardRef((props: ApplyChangeProps, ref: any) => {
  const { onApply, onCancel } = props;

  return (
    <>
      <div
        ref={ref}
        className="inline-apply-hidden"
      >
        <div className="py-4 text-center inline-apply-parent">
          <div className="inline-apply-child">
            <Header>
              <HeaderTitleWrapper>
                <CheckboxTickedLined accent="teal" size="32" />
                <Label id="dialogTitle" className="h1 mb-10 mt-10 px-1">
                  Apply uplift values?
                </Label>
              </HeaderTitleWrapper>
            </Header>
            <p className="uplift-modal-text">You are about to apply uplift values to the updated
              Contract Lines.</p>
            <div className="gap-2 d-sm-flex justify-content-sm-between mb-10 px-4">
              <div className="btn btn-primary btn-lg gap-3" style={{ width: 140 }}>
                <Button
                  buttonStyleType={ButtonStyleType.SECONDARY}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
              </div>

              <div className="btn btn-outline-secondary btn-lg" style={{ width: 140 }}>
                <Button
                  buttonStyleType={ButtonStyleType.PRIMARY}
                  onClick={onApply}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

ApplyChanges.displayName = 'ApplyChanges';
export default ApplyChanges;
